import React from "react";
import { Flex, Icon, Text, VStack } from "@chakra-ui/react";
import { FiInbox } from "react-icons/fi";

const EmptyState = ({ title, description }) => {
  return (
    <Flex align="center" justify="center" py={8}>
      <VStack spacing={2}>
        <Icon as={FiInbox} boxSize={6} color="gray.400" />
        <Text fontWeight="semibold">{title}</Text>
        <Text fontSize="sm" color="gray.500">
          {description}
        </Text>
      </VStack>
    </Flex>
  );
};

export default EmptyState;
